import React from "react";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

function fmtDate(d) {
  try {
    const dt = new Date(d);
    return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
  } catch {
    return String(d || "");
  }
}

export default function TrendChart({ points }) {
  if (!points?.length) return <div className="muted">No trend data yet.</div>;

  const data = points.map((p) => ({
    ...p,
    atLabel: fmtDate(p.at)
  }));

  return (
    <div style={{ width: "100%", height: 260 }}>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 6, right: 12, bottom: 6, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="atLabel" tick={{ fontSize: 11 }} minTickGap={24} />
          <YAxis tick={{ fontSize: 11 }} />
          <Tooltip />
          <Line type="monotone" dataKey="findings_total" />
          <Line type="monotone" dataKey="critical" />
          <Line type="monotone" dataKey="complexity" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
